import axios from "axios";
import { stringify } from "qs";
import { isEmpty, omitBy } from "lodash";
import { security } from "./security";
import { useLoadingStore } from "../hooks/useLoadingStore";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 60000,
  // query params issue: https://github.com/axios/axios/issues/1727
  paramsSerializer: (params) => {
    const paramsTemp = omitBy(params, (value: any) => {
      if (typeof value === "string" || value instanceof Array) {
        return isEmpty(value);
      }
    });
    return stringify(paramsTemp, { arrayFormat: "repeat" });
  },
});

instance.interceptors.request.use(async (config) => {
  if (config.url && !/^\/vouchers\/\w*\/voucher-info$/i.test(config.url)) {
    useLoadingStore.getState().add(config.url);
  }
  const token = await security.getAccessTokenSilently();
  config.headers = {
    Authorization: "Bearer " + token,
  };
  return config;
});

instance.interceptors.response.use(
  (response) => {
    useLoadingStore.getState().remove(response.config.url);
    return response.data;
  },
  (err) => {
    let message;
    if (err.response != null) {
      useLoadingStore.getState().remove(err.response.config.url);
      const { status, data } = err.response;
      message = data?.detail || data?.violations?.[0]?.message || data?.title;
      if (message == null) {
        switch (status) {
          case 400:
            message = "Bad Request";
            break;
          case 401:
            message = "Sorry, you don't have authorization.";
            security.logout({ returnTo: window.location.origin });
            break;
          case 403:
            message = "Sorry, you don't have access to this page.";
            break;
          case 404:
            message = "Sorry, can’t find the specific resource.";
            break;
          case 405:
            message = "Method is incorrect";
            break;
          case 500:
            message = "Sorry, the server is reporting an error.";
            break;
          default:
            message = "Sorry, there are some errors.";
        }
      }
    }
    return Promise.reject(message);
  }
);

export default instance;
